import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { IProductTourStep } from 'src/models/productTour';

interface ITourSteps {
  stepNumber: number;
  totalStep: number;
  currentStep: IProductTourStep;
  steps: IProductTourStep[];
  menu: string;
  submenu: string;
}

interface IProductTourState {
  isTourButtonOpen: boolean;
  isOnTour: boolean;
  currentTour: ITourSteps;
}

const initialState: IProductTourState = {
  isTourButtonOpen: false,
  isOnTour: false,
  currentTour: {
    stepNumber: 0,
    totalStep: 0,
    currentStep: {
      title: '',
      content: '',
      nextButtonText: '',
      showNextButton: false
    },
    steps: [],
    menu: '',
    submenu: ''
  }
};

export const productTour = createSlice({
  name: 'productTour',
  initialState,
  reducers: {
    reducerUpdateButtonTour: (
      state: IProductTourState,
      action: PayloadAction<boolean>
    ) => {
      state.isTourButtonOpen = action.payload;
    },
    reducerUpdateOnTour: (
      state: IProductTourState,
      action: PayloadAction<boolean>
    ) => {
      state.isOnTour = action.payload;
    },
    reducerUpdateTourSteps: (
      state: IProductTourState,
      action: PayloadAction<{
        data: Partial<ITourSteps>;
      }>
    ) => {
      state.currentTour = {
        ...state.currentTour,
        ...action.payload.data
      };
    },
    reducerUpdateNextTourSteps: (state: IProductTourState) => {
      state.currentTour = {
        ...state.currentTour,
        stepNumber: state.currentTour.stepNumber + 1,
        currentStep: state.currentTour.steps[state.currentTour.stepNumber]
      };
    },
    reducerResetTourSteps: (state: IProductTourState) => {
      state.currentTour = initialState.currentTour;
    }
  }
});

export const {
  reducerUpdateButtonTour,
  reducerUpdateOnTour,
  reducerUpdateTourSteps,
  reducerUpdateNextTourSteps,
  reducerResetTourSteps
} = productTour.actions;

export default productTour.reducer;
